import { eventChain, EventChainItemInput } from "./EventChainProvider"
import {
  EventAction as EVA,
  EventLabel as EVL
} from "../index"

type EventTrackingPayload = Omit<EventChainItemInput, "contentType"> & {
  contentType?: EventChainItemInput["contentType"] | string
  [key: string]: unknown
}

export const trackSessionStart = ({
  method
}: {
  method: string
}): void => {
  eventChain.resetChain()
  trackEvent({
    type: EVA.SESSION_START,
    category: "auth" as EventChainItemInput["category"],
    label: EVL.REPORTING,
    meta: { method }
  })
}

export const trackEvent = (
  data: EventTrackingPayload,
  _ga4method?: "fa" | "log" | "raw",
  _ga4Metadata?: Record<string, unknown>
): void => {
  // GA4 handling intentionally lives at the original call sites.
  // This wrapper only queues PostgreSQL event-chain data.
  const allowedEvents = [
    `${EVA.ANSWER}_${EVL.REPORTING}`,
    `${EVA.FINISH}_${EVL.REPORTING}`,
    `${EVA.VIEW}_${EVL.REPORTING}`,
    `${EVA.SESSION}_${EVL.REPORTING}`,
    `${EVA.SESSION_START}_${EVL.REPORTING}`,
    `${EVA.LOGOUT}_${EVL.REPORTING}`,
    `${EVA.START}_${EVL.REPORTING}`,
    `${EVA.RESUME}_${EVL.REPORTING}`,
    `${EVA.PAUSE}_${EVL.REPORTING}`,
    `${EVA.PREVIEW}_${EVL.REPORTING}`,
    `${EVA.REVIEW}_${EVL.REPORTING}`,
    `${EVA.LOGIN}_${EVL.REPORTING}`
  ]
  if (allowedEvents.includes(`${data.type}_${data.label}`)) {
    try {
      eventChain.trackEvent({
        ...data,
        url: window.location.href
      } as EventChainItemInput)
    } catch {
      // Event chaining should not block existing GA4 analytics.
    }
  }
}
